import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { useNavigate } from 'react-router-dom'
import UserTypeDisplay from '../../components/common/UserTypeDisplay'
import { useFilters } from '../../hooks/useFilters'
import { FILTER_TYPES } from '../../constants/filters'
import Pagination from '../../components/common/Pagination'
import StatDisplay from '../../components/common/StatDisplay'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { formatTime } from '../../utils/date.util'
import ReportTicketStatus from '../../components/admin/ReportTicketStatus'

const ReportsPage = () => {
  const navigate = useNavigate()
  const { filters, renderFilters, renderPagination } = useFilters()
  const { data } = useQuery({
    queryKey: QueryKeys.adminReportsTickets(filters),
    queryFn: () => handleGetRequest('/admin/reports', filters),
  })

  const { data: reportStatsData } = useQuery({
    queryKey: QueryKeys.adminReportStats(),
    queryFn: () => handleGetRequest('/admin/reports/stats'),
  })
  const reportStats = reportStatsData?.data || {}

  const tickets = data?.data || []

  return (
    <>
      <div className="flex gap-6 mb-8">
        <StatDisplay label="Total" value={reportStats?.totalCount} />
        <StatDisplay label="Pending" value={reportStats?.pendingCount} />
        <StatDisplay label="In Progress" value={reportStats?.inProgressCount} />
        <StatDisplay label="Resolved" value={reportStats?.resolvedCount} />
      </div>
      <div className="flex gap-4 w-full mb-6">
        {renderFilters([
          FILTER_TYPES.search,
          FILTER_TYPES.contentType,
          FILTER_TYPES.reportTicketStatus,
          FILTER_TYPES.date,
        ])}
      </div>

      <div className="border border-gray-300 rounded-md overflow-hidden bg-background">
        <table className="w-full text-left">
          <thead>
            <tr className="bg-secondary-100 [&>th]:px-6 [&>th]:py-4 [&>th]:font-medium [&>th]:text-black [&>th]:text-base">
              <th>ID</th>
              <th>Reporter</th>
              <th>Reason</th>
              <th>Type</th>
              <th>Status</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tickets.length === 0 ? (
              <tr>
                <td colSpan={6} className="text-center py-8 text-gray-500">
                  No tickets found for the selected filters.
                </td>
              </tr>
            ) : (
              tickets.map((ticket) => (
                <tr
                  key={ticket.id}
                  className="border-t border-gray-200 last:border-b-0 [&>td]:px-6 [&>td]:py-4"
                >
                  <td>{ticket.id}</td>
                  <td>
                    {ticket.reporterName} - <UserTypeDisplay userType={ticket.reporterType} />
                  </td>
                  <td>{ticket.reportReason}</td>

                  <td>
                    <UserTypeDisplay userType={ticket.contentType} />
                  </td>
                  <td>
                    <ReportTicketStatus status={ticket.status} />
                  </td>
                  <td>{formatTime(ticket.createdAt)}</td>
                  <td>
                    <div className="flex gap-2">
                      <button
                        className="bg-secondary-600 text-white rounded-[4px] w-[101px] h-[30px] flex items-center justify-center gap-1 text-[16px] font-medium"
                        onClick={() => navigate(`/admin/moderation/${ticket.id}`)}
                      >
                        View
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {renderPagination(data?.meta)}
    </>
  )
}
export default ReportsPage
